<template>
  <component
    :is="component"
    :dialog="dialog"
    :yjob="yjob"
    :job-rank-star-threshold="jobRankStarThreshold"
    class="tw-bg-white tw-border tw-border-solid tw-border-gray-300 tw-p-4 tw-mb-4 tw-rounded"
  />
</template>

<script>
import gql from 'graphql-tag'
import JobPageDialogsItemFreelancer from '@/components/JobPageDialogsItemFreelancer.vue'
import JobPageDialogsItemRecruiter from '@/components/JobPageDialogsItemRecruiter.vue'
import { graphqlFragmentValidator } from '@/utils/propValidation'

const JOB_PAGE_DIALOGS_ITEM_FRAGMENT_FOR_DIALOG = gql`
  fragment JobPageDialogsItemFragmentForDialog on Dialog {
    hasRecruiter
    hire {
      localId
    }
    freelancer {
      name
    }
  }
`

export default {
  components: {
    JobPageDialogsItemFreelancer,
    JobPageDialogsItemRecruiter,
  },
  fragments: {
    dialog: JOB_PAGE_DIALOGS_ITEM_FRAGMENT_FOR_DIALOG,
  },
  props: {
    dialog: {
      type: Object,
      required: true,
      validator: graphqlFragmentValidator(JOB_PAGE_DIALOGS_ITEM_FRAGMENT_FOR_DIALOG),
    },
    yjob: {
      type: Object,
      required: true,
    },
    jobRankStarThreshold: {
      type: Number,
      default: () => 5,
    },
  },
  computed: {
    component() {
      if (this.dialog.hasRecruiter) {
        return 'JobPageDialogsItemRecruiter'
      }

      return 'JobPageDialogsItemFreelancer'
    },
  },
}
</script>
